// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"ProductImage_imageContainer__9d44E","image":"ProductImage_image__bop_u","imagePicture":"ProductImage_imagePicture__IOxWX"};